// NOTE: These are exact matches
const devHostExactMatches = ['localhost', 'vercel.app']

/**
 * Determine if we believe we should use a Dev or Prod Mixpanel.
 *
 * NOTE: there may be a scenario where process.env.NODE_ENV isn't Dev, but we
 * want events to go into Dev Mixpanel (e.x. Sales)
 */
export const hostnameShouldUseDevMixpanel = (hostname: string) => {
  return (
    devHostExactMatches.includes(hostname) ||
    // The new preview envs have hostnames like: https://preview-XX.preview.hivewatch-dev.com
    // where XX is some number. Trying to catch every number is a losing battle,
    // so we'll do a host contains check to try and catch those
    // Should catch:
    //   - vercel.hivewatch-dev.com
    //   - webapp.sales.hivewatch-dev.com
    //   - review.vercel.hivewatch-dev.com
    //   - webapp.hivewatch-dev.com
    //   - preview-XX.preview.hivewatch-dev.com
    hostname.includes('.hivewatch-dev.') ||
    // hivewatch-test deploys to test.hivewatch.io (a different domain than
    // hivewatch-dev.com), so it needs its own check to land in dev Mixpanel
    // instead of prod. No leading dot: covers both the bare domain and any
    // subdomain of it (e.g. webapp.test.hivewatch.io).
    hostname.includes('test.hivewatch.io')
  )
}

/**
 * Parses a URL to extract the path and query parameters
 * @param url - The URL to parse (e.g., '/floor-plan?floorId=f-1')
 * @returns Object containing the path and properties with query string if present
 */
export const parseUrlForTracking = (
  url: string
): { path: string; properties: Record<string, string> } => {
  const [path, queryString] = url.split('?')
  const properties: Record<string, string> = {}

  if (queryString) {
    properties.query = queryString
  }

  return { path, properties }
}
